/**
 * Field guideline info boxes — hover popovers next to form labels.
 *
 * Content is rendered server-side by the {% guideline %} template tag
 * (hidden .field-guideline-source span); tippy.js displays it with proper
 * viewport collision handling (flips/shifts instead of clipping).
 */
import tippy from 'tippy.js';

export function initFieldGuidelines() {
    document.querySelectorAll('.field-guideline').forEach(el => {
        const source = el.querySelector('.field-guideline-source');
        if (!source) return;
        tippy(el, {
            content: source.innerHTML,
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            maxWidth: 400,
            theme: 'field-guideline',
            placement: 'top',
            delay: [100, 100],
        });
    });
}
